import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useRef, useEffect } from "react";
import { Spin } from "antd";
var LogScrollSentinel = function (_a) {
    var hasMore = _a.hasMore, loading = _a.loading, onLoadMore = _a.onLoadMore;
    var sentinelRef = useRef(null);
    useEffect(function () {
        if (!hasMore || loading)
            return;
        var observer = new IntersectionObserver(function (entries) {
            if (entries[0].isIntersecting && hasMore && !loading) {
                onLoadMore();
            }
        }, { threshold: 0.1 });
        var el = sentinelRef.current;
        if (el) {
            observer.observe(el);
        }
        return function () {
            if (el) {
                observer.unobserve(el);
            }
        };
    }, [hasMore, loading, onLoadMore]);
    return (_jsxs("div", { ref: sentinelRef, style: {
            textAlign: "center",
            padding: "16px 0",
            minHeight: 50,
        }, children: [loading && _jsx(Spin, { size: "small", tip: "Loading more logs..." }), !hasMore && !loading && (_jsx("span", { style: { color: "var(--text-muted)", fontSize: 12 }, children: "\u2014 End of logs \u2014" }))] }));
};
export default LogScrollSentinel;
